module.exports = " <section id=sponsor> <div class=row> <div class=\"columns small-12 medium-10 medium-offset-1\"> <h4>{{ conf.menu.sponsor }}</h4> <div class=row> <diamond-sponsor v-for=\"sponsor in conf.diamondsponsors\" :sponsor=sponsor :conf=conf></diamond-sponsor> </div> <silver-sponsor-row v-for=\"sponsorRow in silverSponsorRows\" :sponsor-row=sponsorRow :conf=conf> </silver-sponsor-row></div> </div> </section> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sponsor.vue
 ** module id = 56
 ** module chunks = 1
 **/